import { Route } from '@angular/router';
import { authenticationGuard, featureFlagsResolver } from '@ps-gui/shared-core';

export const appRoutes: Route[] = [
  {
    path: '',
    loadChildren: () =>
      import('@ps-gui/claims-terminal-extraction').then((m) => m.extractionRoutes),
    canActivate: [authenticationGuard],
    resolve: { featureFlags: featureFlagsResolver },
  },
];
